/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */
// cSpell:disable
import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { getFirestore, initializeFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { createApp } from 'vue'
import { VueFire, VueFireAuth } from 'vuefire'
import { emulatorConfig, firebaseConfig } from '@/config/firebase'
import { registerPlugins } from '@/plugins'
import router from '@/router'
import { initTelemetry } from '@/services/telemetry'
import { logger } from '@/utils/logger'
import App from './App.vue'
/* cSpell:enable */

import 'unfonts.css'
// import '@material-symbols/font-400'
// import '@/assets/mds.css'
// import '@/assets/icon-colors.css'
import '@/assets/ff.css'
// import '@material-symbols/font-400/outlined.css'

const firebaseApp = initializeApp(firebaseConfig)

const auth = getAuth() // only exists on client side
const functions = getFunctions() // getApp() is optional
// connectFirestoreEmulator can only force ssl for *.cloudworkstations.dev hosts, so when
// emulators are enabled (fronted by Caddy's HTTPS port), initialize Firestore with ssl: true directly.
const _db = emulatorConfig.enabled
    ? initializeFirestore(firebaseApp, {
        host: `${emulatorConfig.host}:${emulatorConfig.ports.firestore}`,
        ssl: true,
    })
    : getFirestore()

// Connect to emulators if enabled
if (emulatorConfig.enabled) {
    logger.log('🔧 Using Firebase Emulators:', {
        host: emulatorConfig.host,
        ports: emulatorConfig.ports,
    })

    connectAuthEmulator(auth, `https://${emulatorConfig.host}:${emulatorConfig.ports.auth}`)

    connectFunctionsEmulator(functions, emulatorConfig.host, emulatorConfig.ports.functions)
    // connectFunctionsEmulator only uses https for *.cloudworkstations.dev hosts, so force it
    // here since Caddy exposes an HTTPS-only port in front of the functions emulator.
    const functionsInternal = functions as unknown as { emulatorOrigin: string | null }
    functionsInternal.emulatorOrigin = `https://${emulatorConfig.host}:${emulatorConfig.ports.functions}`
} else {
    // logger.log('☁️ Using Production Firebase')
}

// if (process.env.NODE_ENV === 'production') {
//   import('firebase/analytics')
//     .then(({ getAnalytics }) => {
//       getAnalytics(firebaseApp)
//     })
//     .catch((err) => {
//       console.log('Analytics not loaded', err)
//     })
// }

const app = createApp(App)

// Analytics and Sentry start only if the user has allowed them
initTelemetry(app)

registerPlugins(app)

app.use(VueFire, {
    firebaseApp,
    modules: [
        VueFireAuth(),
    ],
})

app.mount('#app')

// Remove the loading indicator from index.html once the initial navigation has
// finished (router guards wait for Firebase Auth and the user database).
router.isReady().finally(() => {
    document.querySelector('#boot-loader')?.remove()
})
